module.exports = __webpack_public_path__ + "static/media/whatsapp.d6e2a21f.svg";